import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const SummaryBox = ({ message, onClose }) => {
  const success = message.filter((item) => item.status?.toLowerCase() === "success");
  const failure = message.filter((item) => item.status?.toLowerCase() !== "success");

  return (
    <div style={styles.overlay}>
      <div style={styles.alertBox}>

        {/* Header */}
        <div className="d-flex align-items-center mb-3">
          <h5 className="m-0 p-0">NLIS Upload Summary</h5>
          <div className="ms-auto">
            <CloseIcon sx={{ color: "#5F2120", cursor: "pointer" }} onClick={onClose} />
          </div>
        </div>

        {/* Success */}
        <div style={styles.section}>
          <h6 style={{ color: "#2e7d32" }}>✅ Success — {success.length} bod{success.length === 1 ? "y" : "ies"}</h6>
          {success.length > 0 ? (
            <p style={styles.bodyNos}>Body No: {success.map((s) => s.body_no).join(", ")}</p>
          ) : (
            <p style={styles.muted}>None</p>
          )}
        </div>

        <hr style={{ margin: "8px 0" }} />

        {/* Failure */}
        <div style={styles.section}>
          <h6 style={{ color: "#c62828" }}>❌ Failure — {failure.length} bod{failure.length === 1 ? "y" : "ies"}</h6>
          {failure.length > 0 ? (
            failure.map((f, i) => (
              <div key={i} style={styles.failureItem}>
                <p style={styles.bodyNos}><strong>Body No:</strong> {f.body_no}</p>
                {f.message && (
                  <p style={styles.failureMsg}>⚠️ {f.message}</p>
                )}
                {f.action && (
                  <p style={styles.actionMsg}>{f.action}</p>
                )}
              </div>
            ))
          ) : (
            <p style={styles.muted}>None</p>
          )}
        </div>

      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position:        "fixed",
    top:             0,
    left:            0,
    right:           0,
    bottom:          0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display:         "flex",
    alignItems:      "center",
    justifyContent:  "center",
    zIndex:          1500,
  },
  alertBox: {
    backgroundColor: "#EDFDED",
    padding:         "16px 20px",
    borderRadius:    "8px",
    boxShadow:       "0 0 10px rgba(0,0,0,0.2)",
    zIndex:          1502,
    minWidth:        "420px",
    maxWidth:        "560px",
    maxHeight:       "80vh",
    overflowY:       "auto",
    color:           "#1a1a1a",
  },
  section: {
    marginBottom: 8,
  },
  bodyNos: {
    margin:   "2px 0",
    fontSize: 13,
  },
  failureItem: {
    backgroundColor: "#fff3f3",
    border:          "1px solid #ffcdd2",
    borderRadius:    6,
    padding:         "8px 10px",
    marginBottom:    8,
  },
  failureMsg: {
    margin:    "4px 0 2px",
    fontSize:  12,
    color:     "#c62828",
    fontWeight: 500,
  },
  actionMsg: {
    margin:   "2px 0",
    fontSize: 11,
    color:    "#555",
  },
  muted: {
    fontSize: 13,
    color:    "#888",
    margin:   0,
  },
};

export default SummaryBox;